<template>
  <div class="about" style="padding:15px">
    <q-card bordered class="my-card">
      <q-card-section class="bg-purple-6 text-white">
        <div class="row">
          <div class="col-12 col-md-9">
            <div class="row" style="margin: 0 5px 2px">
            <div class="text-h6">Data Produk Industri Rumah Tangga</div>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="row" style="margin: 0 5px 2px">
              <q-input color="light-blue-7" v-model="cari_value" @keyup="cari_data()" outlined square :dense="true" class="bg-white" style="width:85%"/>
              <q-btn glossy class="bg-light-blue-7" @click="mdl_add = true" dense flat icon="add" style="width:15%">
                <q-tooltip class="bg-light-blue-7" transition-show="flip-right" transition-hide="flip-left" :offset="[10, 10]">
                  Tambah Data
                </q-tooltip>
              </q-btn>
            </div>
          </div>
        </div>
      </q-card-section>

      <q-separator dark inset />

      <q-card-section>
        <div class="row" >
          <div class="col-4 col-md-4 q-pa-sm" v-for="(data, index ) in list_data" :key="data.id">
            <q-card class="my-card bg-purple-5 text-white" flat bordered>
              <q-card-section horizontal>
                <q-card-section class="col-7 q-pt-xs">
                  <!-- <div class="text-overline">Overline</div> -->
                  <div class="text-h7 q-mt-sm q-mb-xs">{{data.brand}}</div>
                  <div class="text-caption text-white">
                    Stok : {{ data.stock }}
                  </div>
                  <div class="text-h7 text-white">
                    Rp. {{data.harga}}
                  </div>
                  <div class="text-h6 text-white">
                    <q-badge outline rounded color="white" class="q-pr-sm">
                      <q-icon name="person" color="white" class="q-ml-xs q-mr-xs" /> {{data.pelaku_nama}}
                    </q-badge>
                  </div>
                </q-card-section>

                <q-card-section class="col-5 flex flex-end">
                  <q-img
                    class="rounded-borders"
                    :src="file_path+data.file"
                    style="max-height: 100px;"
                  />
                </q-card-section>
                <!-- <q-card-section>
                  
                </q-card-section> -->
              </q-card-section>

              <q-separator class="text-white" />

              <q-card-actions>
                <div class="col" style="text-align: right;">
                  <q-fab
                    color="white"
                    text-color="purple-5"
                    direction="left"
                    padding="xs"
                  >
                  <template v-slot:icon="{ opened }">
                    <q-icon :class="{ 'example-fab-animate--hover': opened !== true }" name="keyboard_arrow_left" />
                  </template>

                  <template v-slot:active-icon="{ opened }">
                    <q-icon :class="{ 'example-fab-animate': opened === true }" name="close" />
                  </template>
                  <q-fab-action padding="5px" color="white" text-color="cyan-7" @click="mdl_lihat = true, selectData(data)" icon="text_snippet"><q-tooltip class="bg-cyan-7">Lihat Data</q-tooltip></q-fab-action>
                  <q-fab-action padding="5px" color="white" text-color="amber-7" @click="mdl_edit = true, selectData(data)" icon="create"><q-tooltip class="bg-amber-7">Edit Data</q-tooltip></q-fab-action>
                  <q-fab-action padding="5px" color="white" text-color="deep-orange-7" @click="mdl_hapus = true, selectData(data)" icon="delete_forever"><q-tooltip class="bg-deep-orange-7">Hapus Data</q-tooltip></q-fab-action>
                  </q-fab>
                </div>
              </q-card-actions>
            </q-card>
          </div>
        </div>
        <hr class="hrpagin">
        <br>
        <div class="text-center">
          <q-btn @click="btn_prev" glossy color="purple-6" icon="skip_previous" class="paginate_btn" />
            <span class="h_pagination">&nbsp; {{page_first}} - {{page_last}} &nbsp;</span>
          <q-btn @click="btn_next" glossy color="purple-6" icon="skip_next" class="paginate_btn" />
        </div>
        <br>
      </q-card-section>
    </q-card>

          <!-- =================================================== MODAL =========================================================== -->

            <!-- ================================================= MODAL TAMBAH ================================================ -->
              <q-dialog v-model="mdl_add" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-light-blue-7">
                    <div class="text-h6 h_modalhead">Tambah Data</div>
                  </q-card-section>

                  <form @submit.prevent="addData()">
                    <q-card-section class="q-pt-none">
                        <br>
                        <div class="row">
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Kategori</span>
                            <q-select outlined dense v-model="form.kategori" :options="list_kategori" option-label="uraian" option-value="id" class="bg-white margin_input" />
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Pelaku Industri Rumah Tangga</span>
                            <q-select outlined dense v-model="form.pelaku" :options="list_pelaku" option-label="nama" option-value="id" class="bg-white margin_input" />
                          </div>
                          <!-- <div class="col-12 col-md-12">
                            <span class="h_lable">Nama Produk</span>
                            <q-input v-model="form.brand" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div> -->
                          <div class="col-6 col-md-6 margin_input" style="padding-right: 7.5px;">
                            <span class="h_lable">Nama Produk</span>
                            <q-input v-model="form.brand" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6 margin_input" style="padding-left: 7.5px;">
                            <span class="h_lable">Stock</span>
                            <q-input v-model="form.stock" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6 margin_input" style="padding-right: 7.5px;">
                            <span class="h_lable">Harga</span>
                            <q-input v-model="form.harga" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-6 col-md-6 margin_input" style="padding-left: 7.5px;">
                            <span class="h_lable">Diskon (%)</span>
                            <q-input v-model="form.diskon" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">Deskripsi Produk</span>
                            <q-editor v-model="form.keterangan" min-height="10rem" class="bg-white margin_input" />
                          </div>
                          <div class="col-12 col-md-12">
                            <span class="h_lable">File</span>
                            <q-file v-model="form.file" color="light-blue-7" outlined :dense="true" class="bg-white margin_input">
                              <template v-slot:prepend>
                                <q-icon name="attach_file" />
                              </template>
                            </q-file>
                          </div>
                        </div>
                    </q-card-section>

                    <q-card-actions class="bg-grey-3 mdl-footer" align="right">
                        <q-btn :loading="btn_add" color="light-blue-7" type="submit" label="Simpan" />
                        <q-btn label="Kembali" color="grey-7" v-close-popup />
                    </q-card-actions>
                  </form>

                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL TAMBAH ================================================ -->

            <!-- ================================================= MODAL LIHAT ================================================ -->
            <q-dialog v-model="mdl_lihat" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-cyan-7">
                    <div class="text-h6 h_modalhead">Lihat Data</div>
                  </q-card-section>
                  <q-card-section class="q-pt-none q-pl-md q-pr-md">
                    <br>
                    <q-card class="my-card" flat>
                      <q-img :src="file_path+form.file_old" />

                      <q-separator />

                      <q-card-section>

                        <div class="row no-wrap items-center">
                          <div class="col text-h6 ellipsis">
                            {{form.brand}}
                          </div>
                          <div class="col-auto text-purple-12 text-subtitle1 q-pt-xs row items-center">
                            {{form.kategori_uraian}}
                          </div>
                        </div>

                        <div class="text-grey text-caption q-pt-sm" v-html="form.keterangan"></div>
                      </q-card-section>

                      <q-card-section class="q-pt-none">
                        <div class="text-subtitle1">
                          Rp. {{form.harga}}
                        </div>
                        <div class="text-caption text-grey">
                          Stock : {{ form.stock }}
                        </div>
                      </q-card-section>

                      <q-separator />

                      <q-card-section>
                          <q-badge outline rounded color="light-blue-7 q-pa-sm q-mr-sm">
                            <q-icon name="person" color="light-blue-7" class="q-mr-xs" /> {{form.pelaku_nama}}
                          </q-badge>
                          <q-badge outline rounded color="amber-7 q-pa-sm q-mr-sm">
                            <q-icon name="phone" color="amber-7" class="q-mr-xs" /> {{form.pelaku_hp}}
                          </q-badge>
                          <q-badge outline rounded color="deep-orange-7 q-pa-sm q-mr-sm">
                            <q-icon name="mail" color="deep-orange-7" class="q-mr-xs" /> {{form.pelaku_email}}
                          </q-badge>
                      </q-card-section>
                    </q-card>
                  </q-card-section>
                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
                  </q-card-actions>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL LIHAT ================================================ -->

            <!-- ================================================= MODAL EDIT ================================================ -->
            <q-dialog v-model="mdl_edit" persistent>
                <q-card class="mdl-md">
                  <q-card-section class="bg-amber-7">
                    <div class="text-h6 h_modalhead">Edit Data</div>
                  </q-card-section>

                  <form @submit.prevent="editData()">

                  <q-card-section class="q-pt-none">
                    <br>

                    <div class="row">
                      <div class="col-12 col-md-12">
                        <span class="h_lable">Kategori</span>
                        <q-select outlined dense v-model="form.kategori" :options="list_kategori" option-label="uraian" option-value="id" class="bg-white margin_input" />
                      </div>
                      <div class="col-12 col-md-12">
                        <span class="h_lable">Pelaku Industri Rumah Tangga</span>
                        <q-select outlined dense v-model="form.pelaku" :options="list_pelaku" option-label="nama" option-value="id" class="bg-white margin_input" />
                      </div>
                      <div class="col-6 col-md-6 margin_input" style="padding-right: 7.5px;">
                        <span class="h_lable">Nama Produk</span>
                        <q-input v-model="form.brand" color="light-blue-7" outlined :dense="true" class="bg-white margin_input" /> 
                      </div>
                      <div class="col-6 col-md-6 margin_input" style="padding-left: 7.5px;">
                        <span class="h_lable">Stock</span>
                        <q-input v-model="form.stock" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                      </div>
                      <div class="col-6 col-md-6 margin_input" style="padding-right: 7.5px;">
                        <span class="h_lable">Harga</span>
                        <q-input v-model="form.harga" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                      </div>
                      <div class="col-6 col-md-6 margin_input" style="padding-left: 7.5px;">
                        <span class="h_lable">Diskon (%)</span>
                        <q-input v-model="form.diskon" color="light-blue-7" outlined type="number" :dense="true" class="bg-white margin_input" /> 
                      </div>
                      <div class="col-12 col-md-12">
                        <span class="h_lable">Deskripsi Produk</span>
                        <q-editor v-model="form.keterangan" min-height="10rem" class="bg-white margin_input" />
                      </div>
                      <div class="col-12 col-md-12">
                        <span class="h_lable">File</span>
                        <q-file v-model="form.file" color="light-blue-7" outlined :dense="true" class="bg-white margin_input">
                          <template v-slot:prepend>
                            <q-icon name="attach_file" />
                          </template>
                        </q-file>
                      </div>
                    </div>                   

                  </q-card-section>

                  <q-card-actions class="bg-grey-2 mdl-footer" align="right">
                    
                      <q-btn :loading="btn_add" color="amber-7" type="submit" label="Simpan"  />
                      <q-btn label="Kembali" color="grey-7" v-close-popup />
             
                  </q-card-actions>
                  </form>
                </q-card>
              </q-dialog>
            <!-- ================================================= MODAL EDIT ================================================ -->

            <!-- ================================================ MODAL HAPUS ================================================ -->
            <q-dialog v-model="mdl_hapus" persistent>
                    <q-card class="mdl-sm ">
                      <q-card-section class="q-pt-none text-center bg-deep-orange-3">
                          <form @submit.prevent="removeData(form.id, form.file_old)">
                              <br>
                              <img src="img/alert.png" alt="" width="75"> <br>
                              <span class="h_notifikasi">APAKAH ANDA YAKIN INGIN MENGHAPUS DATA INI??</span>
                              <input type="submit" style="position: absolute; left: -9999px"/>
                              <br>
                              <br>
                            <q-btn label="Kembali" size="sm" color="grey-7"  v-close-popup/>
                            &nbsp;
                            <q-btn type="submit" label="Hapus" size="sm" color="deep-orange-7" v-close-popup/>

                          </form>
                      </q-card-section>
                    </q-card>
                  </q-dialog>

            <!-- ================================================ MODAL HAPUS ================================================ -->

          <!-- =================================================== MODAL =========================================================== -->

  </div>
</template>

<script>
export default {
  name: 'UmumPage',
  data() {
    return {
      form : {
        id : '',
        kategori : '',
        pelaku : '',
        brand : '',
        harga : '',
        diskon : '',
        stock : '',
        keterangan : '',
        file : '',
        file_old : '',
        createdAt : '',
        editedAt : '',
        userId : '',
        pelaku_nama : '',
        pelaku_hp : '',
        pelaku_email : '',
        kategori_uraian : '',
      },

      profile : {
        menu_klp : '',
      },

      ruteView : '',
      listPelaku : '',

      list_data : [],
      list_pelaku : [],
      list_kategori : [],

      file_path: this.$store.state.url.URL_APP + "uploads/",

      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_add: false,
      mdl_lihat: false,
      mdl_edit: false,
      mdl_hapus: false,
    }
  },
  methods: {
    getView : function(){
      this.$store.commit('showLoading');
      if (this.profile.menu_klp == 17) {
        this.ruteView = "viewAdmin"
      } else {
        this.ruteView = "viewUser"
      }
      fetch(this.$store.state.url.URL_PRODUK  + this.ruteView, {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              pelakuId : this.form.pelakuId
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    getPelaku : function (){
      if (this.profile.menu_klp == 17) {
        this.listPelaku = "listAdmin"
      } else {
        this.listPelaku = "listUser"
      }
      fetch(this.$store.state.url.URL_PELAKU + this.listPelaku, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
      })
      .then(res => res.json())
      .then(res_data => {
        this.list_pelaku = res_data;
        console.log(this.list_pelaku)
      });
    },

    getKategori : function (){
      fetch(this.$store.state.url.URL_KATEGORI + "list", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
      })
      .then(res => res.json())
      .then(res_data => {
        this.list_kategori = res_data;
        console.log(this.list_kategori)
      });
    },

    addData : function() {
      // console.log(this.form);
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_PRODUK + "addData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'light-blue-7', 'check_circle_outline');
          console.log(res_data);
          this.getView();
      });
    },

    editData : function(){
      var formData = new FormData();
      formData.append('data', JSON.stringify(this.form))
      formData.append('file', this.form.file)
      fetch(this.$store.state.url.URL_PRODUK + "editData", {
          method: "POST",
          headers: {
            // "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: formData
      }).then(res_data => {
          this.Notify('Sukses Mengubah Data', 'amber-7', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(a, b){
      fetch(this.$store.state.url.URL_PRODUK + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a, file : b})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'deep-orange-7', 'check_circle_outline');
          this.getView();
      });

    },

    selectData: function(data) {
      console.log(data);
      this.form.id = data.id
      // this.form.kategori = data.kategoriId
      // this.form.pelaku = data.pelakuId
      this.form.brand = data.brand
      this.form.harga = data.harga
      this.form.stock = data.stock
      this.form.keterangan = data.keterangan
      this.form.file = this.form.file
      this.form.file_old =  data.file
      this.form.createdAt = data.createdAt
      this.form.editedAt = data.editedAt
      this.form.userId = data.userId
      this.form.pelaku_nama = data.pelaku_nama
      this.form.pelaku_hp = data.pelaku_hp
      this.form.pelaku_email = data.pelaku_email
      this.form.kategori_uraian = data.kategori_uraian
    },

    // ====================================== PAGINATE ====================================
    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

    // ====================================== PAGINATE ====================================

  },
  mounted() {
    var get_profile = JSON.parse(localStorage.profile);
      this.profile.menu_klp = get_profile.profile.menu_klp;
      console.log(this.profile.menu_klp);
    this.getView();
    this.getPelaku();
    this.getKategori();
  }
}
</script>

<style lang="sass" scoped>
.example-fab-animate,
.q-fab:hover .example-fab-animate--hover
  animation: example-fab-animate 0.82s cubic-bezier(.36,.07,.19,.97) both
  transform: translate3d(0, 0, 0)
  backface-visibility: hidden
  perspective: 1000px

@keyframes example-fab-animate
  10%, 90%
    transform: translate3d(-1px, 0, 0)

  20%, 80%
    transform: translate3d(2px, 0, 0)

  30%, 50%, 70%
    transform: translate3d(-4px, 0, 0)

  40%, 60%
    transform: translate3d(4px, 0, 0)
</style>
